import styled from "styled-components";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)``;

export const StyledToggleButton = styled(ToggleButton)`
    && {
        //styleName: text/Inter Regular 12px;

        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: center;

        padding: 6px 18px;

        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
        border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
        background-color: ${UIStyleConstants.WHITE_COLOR};

        &.MuiToggleButton-root.Mui-selected {
            background: ${UIStyleConstants.BLUE_COLOR};
            color: ${UIStyleConstants.WHITE_COLOR};
        }
    }
`;
